(function() {
	'use strict';

	angular.module('app.core').filter('decodeURIComponent', function($window) {
		return $window.decodeURIComponent;
	});
})();;